/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Approve_Addons_NoneInputs */



/**
* | output |
* | --- |
* | "No add-ons — seats and the prepaid budget only." |
*
* @param {Partner_Org_Contract_Approve_Addons_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_addons_none = /** @type {((inputs?: Partner_Org_Contract_Approve_Addons_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_Addons_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Zusatzoptionen — nur Plätze und das vorausbezahlte Budget.")
	return /** @type {LocalizedString} */ ("No add-ons — seats and the prepaid budget only.")
});